import { useEffect, useState } from "react";
import { useIsVerified } from "src/components/email-verification";
import {
  MainCard,
  MainCardContent,
  MainCardTitle,
} from "src/components/main-card-type.tsx";
import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  removeMask,
  sanitizeBrlValue,
  saveCalculatorData,
} from "src/utils/functions";
import { Button } from "src/components/ui/button";
import { calcularParcelamento, PixResponse } from "../utils/pix-parcelado";
import { renderTooltip } from "src/calculators/comparador-de-renda-fixa/components/tooltip";

export const CalculadoraCDBInputCard = ({
  setResults,
}: {
  setResults: (value: PixResponse | null) => void;
}) => {
  const [message, setMessage] = useState<string>("");
  const isVerified = useIsVerified();

  const [valorPix, setvalorPix] = useState("");
  const [numeroParcelas, setNumeroParcelas] = useState("");
  const [valorParcela, setValorParcela] = useState("");
  const [jurosMensal, setJurosMensal] = useState("");
  const [selectValorParcela, setSelectValorParcela] = useState(false);
  const calculatorKey = "pix-parcelado";
  function handleOnChange() {
    setSelectValorParcela(!selectValorParcela);
    setValorParcela("");
  }
  function handleSave() {
    saveCalculatorData(calculatorKey, {
      valorPix,
      numeroParcelas,
      valorParcela,
      jurosMensal,
    });
  }

  function clear() {
    setvalorPix("");
    setNumeroParcelas("");
    setValorParcela("");
    setMessage("");
  }

  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;
    setvalorPix((savedData.valorPix as string) || "");
    setNumeroParcelas((savedData.numeroParcelas as string) || "");
    setValorParcela((savedData.valorParcela as string) || "");
    setJurosMensal((savedData.jurosMensal as string) || "");
  }, []);
  function calcular() {
    if (!valorPix) {
      setMessage("Por favor adicione um valor ao campo Valor do Pix.");
      setResults(null);
      return;
    }
    if (!numeroParcelas) {
      setMessage("Por favor adicione um valor ao campo Número de Parcelas.");
      setResults(null);
      return;
    }
    const _valorPix = removeMask(valorPix);
    const _valorParcela = removeMask(valorParcela);
    if (_valorParcela >= _valorPix) {
      setMessage(
        "O valor do Pix não pode ser igual ou maior ao valor da parcela."
      );
      setResults(null);
      return;
    }
    setMessage("");

    const calculoParcelado = calcularParcelamento({
      valorPix: valorPix.replace(/\./g, "").replace(",", "."),
      numeroParcela: numeroParcelas,
      valorParcela: valorParcela.replace(/\./g, "").replace(",", "."),
      taxaMensal: jurosMensal,
    });

    const resultado = {
      tabela: calculoParcelado.tabela,
      totalTaxaMensal: calculoParcelado._taxaMensal,
      totais: calculoParcelado.totais,
      selectValorParcela: selectValorParcela,
    };

    setResults(resultado);
  }

  return (
    <MainCard>
      <MainCardTitle>Calculadora de juros no Pix Parcelado</MainCardTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
          checkCalculatorUsageLimitAndRedirect(calcular);
        }}
      >
        <MainCardContent>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Valor do Pix *
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="00,00"
                type="text"
                value={valorPix}
                onChange={(event) => setvalorPix(sanitizeBrlValue(event))}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Número de Parcelas *
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="0"
                type="number"
                value={numeroParcelas}
                onChange={(event) => setNumeroParcelas(event.target.value)}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Juros Mensal (%) *
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="0"
                type="number"
                value={jurosMensal}
                onChange={(event) => setJurosMensal(event.target.value)}
              />
            </div>
          </div>
          <div className="mb-4 mt-9 max-md:mt-3">
            <input type="checkbox" id="corrigido" onChange={handleOnChange} />
            <label className="pl-2" htmlFor="corrigido">
              Incluir Valor da Parcela
            </label>
          </div>
          {selectValorParcela ? (
            <div>
              <label
                className="block mb-2 font-medium text-sm"
                htmlFor="bruto-id"
              >
                Valor da Parcela
                {renderTooltip(
                  "Digite a taxa de rentabilidade do investimento"
                )}
              </label>
              <div className="flex border">
                <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                  R$
                </span>
                <input
                  className="flex-1 p-2 min-w-[100px]"
                  id="bruto-id"
                  placeholder="00,00"
                  type="text"
                  value={valorParcela}
                  onChange={(event) => setValorParcela(sanitizeBrlValue(event))}
                />
              </div>
            </div>
          ) : null}
        </MainCardContent>
        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>
          <div className="flex flex-col sm:flex-row items-center gap-2">
            <Button onClick={clear} type="button" variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>
      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
    </MainCard>
  );
};
